<template>
  <div class="vx-row mb-2">
    <div class="vx-col w-full">
      <vs-input
        class="w-full"
        ref="password"
        type="password"
        v-validate="'required|min:10'"
        name="password"
        :label-placeholder="fieldLabel"
        v-model="password"
        @keyup="changeHandler('password')"
      />
      <span class="text-danger text-sm" v-show="errors.has('password')">{{
        errors.first("password")
      }}</span>

      <vs-input
        type="password"
        v-validate="'min:10|confirmed:password'"
        data-vv-validate-on="blur"
        data-vv-as="password"
        name="password_confirmation"
        label-placeholder="Confirm Password"
        placeholder="Confirm Password"
        v-model="confirm_password"
        class="w-full mt-6"
        @keyup="changeHandler('password_confirmation')"
      />
      <span class="text-danger text-sm">{{
        errors.first("password_confirmation")
      }}</span>
    </div>
  </div>
</template> 
<script>
import { sidebarMixin } from "../sidebarMixin";
export default {
  mixins: [sidebarMixin],
  props: {
    index: String,
    structure: {
      type: Object,
      default: () => {},
      required: true,
    },
    value: String,
    validation: "",
  },
  data() {
    return {
      localVal: "",
      name: "",
      password: "",
      confirm_password: "",
      confirmValidation: "",
    };
  },

  methods: {
    changeHandler(index) {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
       
        this.$emit("error", { index: index, value: result });
      });
    }, 
  },

  created() {
    //we emit the default value because if user does not touch it won't be captured in the array
 
    this.$emit("input", { index: "password", value: this.value });
    this.$emit("input", { index: "password_confirmation", value: this.value });

    this.$watch("password", (value) => {
      this.$emit("input", { index: "password", value: value });
    });

    this.$watch("confirm_password", (value) => {
      var errorVal = false;

      this.$emit("input", { index: "password_confirmation", value: value });
    });
  },
};
</script>